import { render, staticRenderFns } from "./VechicleCommission.vue?vue&type=template&id=cb5d1f38&"
import script from "./VechicleCommission.vue?vue&type=script&lang=js&"
export * from "./VechicleCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports